import { render, staticRenderFns } from "./product.vue?vue&type=template&id=785b5166&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=785b5166&prod&lang=scss"
import style1 from "./product.vue?vue&type=style&index=1&id=785b5166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785b5166",
  null
  
)

export default component.exports